<template>
  <div class="my-item z-info">
    <template v-if="list && list.items.length">
      <div style="min-height: 400px;">
        <Row :gutter="30">
          <Col span="12" v-for="(item, index) in list.items" :key="'releaseInt-' + index">
            <div class="my-info-list">
              <div class="my-info-list-t">
                <span>发布时间：{{item.inTime|dateFormat}}</span>
                <span>点赞：{{item.zanCount}} 留言：{{item.commentList.totalCount}}</span>
              </div>
              <div class="my-info-list-m">
                <p :title="item.information">{{item.information}}</p>
              </div>
              <div class="my-info-list-img">
                <div
                  class="my-info-list-img-box"
                  v-for="(it, index) in item.photo"
                  :key="'my-item-img-' + index"
                >
                  <img :src="it" v-if="index <= 5" />
                  <div class="my-info-list-img-cover" :key="'my-item-img-cover-' + index">
                    <Icon type="ios-eye-outline" @click.native="handleView(it)"></Icon>
                  </div>
                </div>
              </div>
              <div class="my-info-list-b">
                <div class="z-del">
                  <Poptip confirm title="确认删除该商机吗 ?" @on-ok="delItem(item)">
                    <span style="color: #f00;">删除商机</span>
                  </Poptip>
                </div>
                <div class="c-line"></div>
                <div @click="showEdit(item)">
                  管理留言
                  <!-- <span
                    v-if="item && item.commentList.totalCount"
                  >({{item.commentList.totalCount}})</span> -->
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
    </template>
    <div class="u-empty" v-else>暂无数据</div>

    <!-- 新增 -->
    <addRelease :show="add" @finish="init()" @close="hideAdd()" />

    <!-- 编辑 -->
    <msgRelease :show="edit" :info="editInfo" @close="hideEdit()" />

    <iModal title="图片查看" cancel-text v-model="visible">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addRelease from "./components/add-release.vue";
import msgRelease from "./components/msg-release.vue";

export default {
  name: "my-info",
  data() {
    return {
      imgName: "",
      visible: false,
      deleted: false,
      edit: false,
      add: false,
      list: null,
      editInfo: null,
      delInfo: null,

      pageSize: 12,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  components: {
    addRelease,
    msgRelease
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getRelease: "releaseModule/getRelease",
      delRelease: "releaseModule/delRelease"
    }),
    async init() {
      let res = await this.getRelease(this.option);
      if (res && res.items) {
        res.items.map(c => {
          if (c.photo.indexOf("[") !== -1) {
            c.photo = JSON.parse(c.photo);
          } else {
            c.photo = [];
          }
        });
      }
      this.list = res;
      if (this.list) {
        this.pageSize = this.list.pageSize;
        this.pageIndex = this.list.pageIndex;
        this.totalCount = this.list.totalCount;
        this.$emit("showNum", this.list.totalCount);
      }
    },
    del(item) {
      this.$Modal.confirm({
        content: `确认删除 ${item.title} 此商机吗 `,
        onOk: () => {
          this.delItem(item);
        },
        onCancel: () => {
          this.deleted = false;
        }
      });
    },
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    async delItem(item) {
      let result = await this.delRelease(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showAdd() {
      this.add = true;
    },
    hideAdd() {
      this.add = false;
    },
    showEdit(item) {
      this.edit = true;
      this.editInfo = item;
    },
    hideEdit() {
      this.edit = false;
      this.editInfo = null;
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
      
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      
    }
  }
};
</script>

<style scoped lang="scss">
.my-item {
  min-width: 1000px;
  padding: 30px;

  &-box {
    background-color: #fff;
    margin-bottom: 30px;
  }

  .mi {
    &-top {
      height: 240px;
      position: relative;
      background-color: #f8f9fb;

      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }

    &-title {
      padding: 10px 10px 10px 10px;
      font-size: 16px;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &-tool {
      display: flex;
      align-items: center;
      justify-content: space-around;
      background-color: #f8f9fb;

      &-item {
        flex: 1;
        line-height: 48px;
        font-size: 14px;
        color: #808080;
        cursor: pointer;
        text-align: center;
        &:hover {
          color: #1890ff;
        }

        &.z-del {
          &:hover {
            color: #f00;
          }
        }
      }

      &-line {
        color: #e8e8e8;
        font-size: 20px;
      }
    }
  }

  .my-page {
    padding-bottom: 50px;
  }
}

.my-info {
  &-list {
    width: 100%;
    height: 288px;
    margin: 0 22px 19px 0;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(53, 153, 231, 0.2);
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    &-img {
      padding: 0 20px;
      &-box {
        position: relative;
        margin: 0 20px 20px 0;
        width: 60px;
        height: 60px;
        display: inline-block;
      }
      &-cover {
        opacity: 0;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          opacity: 1;
        }
        i {
          color: #fff;
          font-size: 20px;
          cursor: pointer;
          margin: 0 2px;
        }
      }
      img {
        width: 60px;
        height: 60px;
        display: inline-block;
      }
    }
    &-t {
      display: flex;
      justify-content: space-between;
      padding: 15px 20px 15px;
    }
    &-m {
      flex: 1;
      width: 100%;
      padding: 0 20px;
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        line-height: 1.7;
      }
    }
    &-b {
      display: flex;
      justify-content: space-around;
      line-height: 47px;
      background-color: #f7f9fa;
      padding: 0 20px;
      div {
        text-align: center;
        cursor: pointer;
      }
      div:first-child {
        color: #ff0000;
      }
      .c-line {
        border-right: 1px solid #e8e8e8;
        height: 22px;
        padding-top: 12px;
      }
      div:last-child {
        color: #1890ff;
      }
    }
  }
}
</style> 
